export function FlipHorizontalIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M4 10C3.63181 10 3.33333 10.2985 3.33333 10.6667L3.33333 11.3333C3.33333 12.4379 4.22876 13.3333 5.33333 13.3333L10.6667 13.3333C11.7712 13.3333 12.6667 12.4379 12.6667 11.3333L12.6667 10.6667C12.6667 10.2985 12.3682 10 12 10C11.6318 10 11.3333 10.2985 11.3333 10.6667L11.3333 11.3333C11.3333 11.7015 11.0349 12 10.6667 12L5.33333 12C4.96514 12 4.66667 11.7015 4.66667 11.3333L4.66667 10.6667C4.66667 10.2985 4.36819 10 4 10Z"
      />
      <path
        fill="currentColor"
        d="M12.6667 8.66667L12.6667 4.66667C12.6667 3.5621 11.7712 2.66667 10.6667 2.66667L5.33333 2.66667C4.22876 2.66667 3.33333 3.5621 3.33333 4.66667L3.33333 8.66667L4.66667 8.66667L4.66667 4.66667C4.66667 4.29848 4.96514 4 5.33333 4L10.6667 4C11.0349 4 11.3333 4.29848 11.3333 4.66667L11.3333 8.66667L12.6667 8.66667Z"
      />
      <path
        fill="currentColor"
        d="M13.3333 7.33333C13.7015 7.33333 14 7.63181 14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667L2.66667 8.66667C2.29848 8.66667 2 8.36819 2 8C2 7.63181 2.29848 7.33334 2.66667 7.33334L13.3333 7.33333Z"
      />
    </svg>
  );
}
